.table-cell {
    composes: cell from '../styles.module.css';
}

.border--right {
    border-right: var(--border-hairline);
}

.border--left {
    border-left: var(--border-hairline);
}

.data-type--right-align {
    text-align: right;
    justify-content: flex-end;
}

.data-type--center-align {
    text-align: center;
    justify-content: center;
}

.table-cell.compact {
    padding: 8px;
}

.less-bottom-padding {
    padding-bottom: 8px;
}

.edit-in-place {
    padding: 0;
}

.truncated {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.truncated > button {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
}

.text-is-dk-grey {
    color: var(--grey-dk);
}

.wrap {
    overflow-wrap: anywhere;
}

.is-top-aligned {
    align-items: flex-start;
}
